import { Box, CircularProgress } from "@mui/material";
import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuth from "../hooks/auth.hook";

interface ProviderProps {
  children: ReactNode;
}

export const RequireAdmin: FC<ProviderProps> = ({ children }) => {
  const location = useLocation();
  const { isAdmin, isAuthenticated, roles } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length === 0) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
